(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/overview-list.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/overview-list.js');
"use strict";


const OverviewList = _ref => {
  let {
    vouchers = [],
    history,
    toName,
    message,
    personalGreeting
  } = _ref;
  const OverviewItemInfo = svs.ticket_gifts.redeem.components.OverviewItemInfo;
  const BubbleInfo = svs.tur.bubbleInfo.components.BubbleInfo;
  const Button = svs.ui.Button;
  const {
    browser,
    constants: {
      EXPIRES_15M
    }
  } = svs.components.Storage;
  const {
    TICKETS_DOMAIN,
    TICKETS_KEY
  } = svs.ticket_gifts.constants;
  const {
    bubbleInfoHeader
  } = svs.ticket_gifts.functions;
  const playLink = giftCode => history && history.push("".concat(history.location.pathname, "/spela/").concat(giftCode));

  const handleVoucherClick = giftCode => {
    const unredeemed = vouchers.filter(voucher => !voucher.isRedeemed);
    const last = unredeemed.splice(0, _.findIndex(unredeemed, voucher => voucher.giftCode === giftCode));
    browser.set(TICKETS_KEY, TICKETS_DOMAIN, [...unredeemed, ...last], EXPIRES_15M);
    playLink(giftCode);
  };
  const handlePlayAllClick = e => {
    e && e.preventDefault();
    const unredeemed = vouchers.filter(voucher => !voucher.isRedeemed);
    if (!unredeemed.length) return;
    browser.set(TICKETS_KEY, TICKETS_DOMAIN, unredeemed, EXPIRES_15M);
    svs.ticketgames.ticketUtility.utils.tracking.trackScratchAllTickets(svs.ticket_gifts.chooseGameForVoucher(unredeemed[0]).type);
    playLink(unredeemed[0].giftCode);
  };
  const allRedeemed = vouchers.reduce((c, n) => c && n.isRedeemed, true);
  const activeVoucherCount = vouchers.filter(voucher => !voucher.isRedeemed).length;
  return React.createElement("div", {
    className: "padding-1 tg-container",
    "data-testid": "overview-list"
  }, React.createElement("div", {
    className: "padding-top-1"
  }, React.createElement(BubbleInfo, {
    className: "bubble-info-container",
    header: bubbleInfoHeader(personalGreeting, toName)
  }, message)), vouchers.length > 0 && !allRedeemed && React.createElement("p", {
    className: "f-800 padding-top-1"
  }, vouchers.length === 1 ? 'Din presentlott' : "Dina ".concat(vouchers.length, " presentlotter")), !vouchers.length || allRedeemed ? React.createElement("p", null, "Alla lotter \xE4r inl\xF6sta. Se resultatet i", ' ', React.createElement("a", {
    className: "qa-redirect-to-mina-sidor-a",
    href: svs.core.urlMapping.get('myBetsHome')
  }, "Mina spel.")) : React.createElement(React.Fragment, null, React.createElement("p", {
    className: "padding-bottom-1"
  }, "Du kan v\xE4lja att skrapa alla lotterna efter varandra eller en och en."), React.createElement("div", {
    className: "margin-bottom-2"
  }, React.createElement(Button, {
    block: true,
    className: "qa-play-all-tickets play-all-btn",
    focus: true,
    onClick: handlePlayAllClick
  }, activeVoucherCount === 1 ? 'Skrapa lott' : 'Skrapa alla lotter'))), React.createElement("div", {
    className: "overview-list",
    "data-testid": "vouchers"
  }, vouchers.sort((a, b) => Boolean(b.availableOnline) - Boolean(a.availableOnline)).sort((a, b) => Boolean(a.isRedeemed) - Boolean(b.isRedeemed)).map(voucher => React.createElement(OverviewItemInfo, {
    isRedeemed: voucher.isRedeemed,
    key: "overview_list_".concat(voucher.giftCode),
    onClick: handleVoucherClick,
    ticketImg: voucher.img,
    ticketName: voucher.ticketName,
    ticketPrice: voucher.ticketPrice,
    voucherCode: voucher.giftCode
  }))));
};
setGlobal('svs.ticket_gifts.redeem.components.OverviewList', OverviewList);

 })(window);